import { Link } from "react-router-dom";

import { Homepage, CategoryProduct } from "../../@types/lang";
import Title from "../shared/Title";
import ProductInfo from "../../assets/images/products/product_info.png";
import Description from "../shared/Description";
import { useEffect, useState } from "react";

type Props = {
  lang: Homepage;
  products: CategoryProduct[];
};

const Products = ({ lang, products }: Props) => {
  const [firstProduct, setFirstProduct] = useState<CategoryProduct>(
    products[0],
  );

  useEffect(() => {
    setFirstProduct(products[0]);
  }, [products]);

  return (
    <>
      <div className="flex flex-col space-y-[50px]">
        <div className="flex flex-col lg:flex-row gap-6 items-center">
          <div className="flex flex-col justify-start space-y-8 px-6 lg:pl-20">
            <Title text={lang.product_title} type="p" />
            <Description text={firstProduct.shortDescription} />
            <Link
              to={`/product/${firstProduct.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-[#504E48] hover:bg-[#504E04] text-center mt-4 w-max rounded-[10px] px-6 py-3 text-white text-xs lg:text-lg cursor-pointer"
            >
              {lang.see_all_btn || "-"}
            </Link>
          </div>
          <div className="flex-1 h-full min-w-[300px] lg:min-w-[500px]">
            <img
              src={ProductInfo}
              alt="Product Info"
              className="w-full h-full object-contain"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
